import { useAccount } from "wagmi";

export const useIsPrivyCrossApp = () => {
  const { connector } = useAccount()
  return { isPrivyCrossApp: connector?.name === "Abstract" }
}
